import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import { integrationHealthRepository } from "./integration-health.repository";
import {
  IntegrationHealthPage,
  IntegrationHealthQuery,
} from "./types/integration-health.entity";

const integrationHealthService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getIntegrationHealth: builder.query<
      IntegrationHealthPage,
      IntegrationHealthQuery
    >({
      queryFn: async ({ offset }) => {
        const result = await executeQuery(() =>
          integrationHealthRepository.find(offset),
        );

        if ("error" in result) return { error: result.error } as any;
        return { data: result.data as IntegrationHealthPage };
      },
    }),
  }),
});

export const { useGetIntegrationHealthQuery } = integrationHealthService;
